<div class="loader-wrapper" [class.loderhide]="!show">
   <div class="loader">
     <div class="loader-bar"></div>
     <div class="loader-bar"></div>
     <div class="loader-bar"></div>
     <div class="loader-bar"></div>
     <div class="loader-bar"></div>
     <div class="loader-ball"></div>
   </div>
 </div>